export const IntegrationsTabsOptions = {
  API_KEYS: 'API_KEYS',
  HOOKS: 'HOOKS',
}

export type IntegrationsTabsOption =
  (typeof IntegrationsTabsOptions)[keyof typeof IntegrationsTabsOptions]

export interface NotificationDestination {
  id: string
  url: string
  target?: string
  type: string
  eventCodes: string[]
  publicKey: string
  signingMode: string
  description: string
}

interface PagedResponse<T> {
  pageNumber: number
  pageSize: number
  totalElements: number
  content: T[]
}

export type NotificationPagedResponse = PagedResponse<NotificationDestination>

export interface NotificationEvent {
  code: string
  schema: string
}
